import { addGlobalError } from 'containers/App/actions';
import { MY_QUOTES_FULL_PATH, DASHBOARD_LIFE_PATH } from 'routes/constants';
import { getAuthHeader } from 'util/authHeader';

import { Options } from './types';

export const continueOnlineSubmit = ({
  lifeApplicationReferenceId,
  auth,
  dispatch,
  navigate,
}: Options) =>
  fetch('/api/life/continue-online/submit', {
    headers: {
      Accept: 'application/json',
      Authorization: getAuthHeader(auth) ?? '',
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify({
      internal_submit: 'true',
      reference_id: lifeApplicationReferenceId,
    }),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }

      throw Error(`Error fetching carrier quotes eligibility: ${res.status} (${res.statusText})`);
    })
    .then((data) => {
      if (data.carrier_quotes_eligible) {
        navigate(MY_QUOTES_FULL_PATH);
      } else {
        window.location.assign(DASHBOARD_LIFE_PATH);
      }
    })
    .catch((error) => {
      console.error(error);
      dispatch(addGlobalError());
    });
